(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProgEligEmployee', ProgEligEmployee);

    ProgEligEmployee.$inject = ['$resource', 'DateUtils'];

    function ProgEligEmployee ($resource, DateUtils) {
        var resourceUrl =  'api/prog-elig-employees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/prog-elig-employees/filter',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }
})();
